import {
  FINGER_COLORS,
  FINGER_NAMES,
  keyDefForChar,
  resolveExpectedKey,
} from '../data/keyboardLayouts';
import type { Finger, KeyboardLayoutId } from '../types';

export interface FingerGuideEntry {
  char: string;
  displayChar: string;
  fingerName: string;
  colorClass: string;
}

function displayCharForKey(char: string): string {
  if (char === ' ') return 'Mellemrum';
  if (char === ',') return 'Komma';
  if (char === '.') return 'Punktum';
  if (char === ';') return 'Semikolon';
  if (char === ':') return 'Kolon';
  if (char === '?') return 'Spørgsmålstegn';
  if (char === '!') return 'Udråbstegn';
  if (char === '@') return '@';
  return char.toUpperCase();
}

export function fingerGuidesForKeys(
  keys: string[],
  layoutId: KeyboardLayoutId,
): FingerGuideEntry[] {
  const seen = new Set<string>();
  const out: FingerGuideEntry[] = [];
  for (const raw of keys) {
    const ch = raw === ' ' ? ' ' : raw;
    const dedupe = ch === ' ' ? ' ' : ch.toLowerCase();
    if (seen.has(dedupe) && ch !== raw) continue;
    seen.add(dedupe);
    seen.add(ch);

    const resolved = resolveExpectedKey(ch, layoutId);
    const def = resolved.def ?? keyDefForChar(ch, layoutId);
    if (!def) continue;

    const displayChar = resolved.needsShift
      ? `Shift + ${displayCharForKey(resolved.baseChar)}`
      : displayCharForKey(ch);

    const fingerName = resolved.needsShift
      ? `Hold Shift, tryk ${displayCharForKey(resolved.baseChar)} (${FINGER_NAMES[def.finger]})`
      : FINGER_NAMES[def.finger];

    out.push({
      char: ch,
      displayChar,
      fingerName,
      colorClass: FINGER_COLORS[def.finger as Finger],
    });
  }
  return out;
}
